import axios from '@/utils/request'
import base from '../base'


export function companyListAll() {
  return axios.get(`${base.url}/auth/company/listAll`);
}
export function mycompanyInfo() {
  return axios.get(`${base.url}/auth/company/info`);
}
